import React from 'react';

function Airplane(props) {
  return (
    <svg viewBox="0 0 27 21" stroke="black" {...props}>
      <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <path d="M23.326 2.187L7.95 8.875 4.575 7.187.638 8.876 5.7 13.938l8.438-3.376-3.375 9 4.5-2.25 4.5-9 5.284-1.968a2.25 2.25 0 10-1.721-4.157z" />
        <path d="M18.269 4.386l-7.49-3.091-4.157 1.722 7.581 3.138" />
      </g>
    </svg>
  );
}

export default Airplane;
